$(document).ready(function() {
  
  
//  About Page - Truncator
  (function() {
    var showChar = 3629;
    var ellipsestext = "...";

    $(".truncate").each(function() {
      var content = $(this).html();
      if (content.length > showChar) {
        var c = content.substr(0, showChar);
        var h = content;
        var html =
            '<div class="truncate-text" style="display:block; text-align: center;">' +
          c +
          '<span class="moreellipses">' +
          ellipsestext + '</div>' +
          '&nbsp;&nbsp;<span class="morelessWrap"><a href="" class="moreless more">English</a></span></span></div><div class="truncate-text" style="display:none"></span>' +
          h +
          '<span class="morelessWrap"><a href="" class="moreless less">סגור</a></span></span>';

        $(this).html(html);
      }
    });
    $(".moreless").click(function() {
      var thisEl = $(this);
      var cT = thisEl.closest(".truncate-text");
      var tX = ".truncate-text";

      if (thisEl.hasClass("less")) {
        cT.prev(tX).toggle();
        cT.slideToggle();
        $(window).scrollTop(0);
      } else {
        cT.toggle();
        cT.next(tX).fadeToggle();
      }
      return false;
    });
  })();
  
  
  
	/* Variant images swap */
	const mainImg = document.querySelector('.is-selected img');
// 	const original = mainImg.cloneNode(true);
  	
  /*liran added*/
  const imageWrap = document.querySelector('.image-wrap');
  const viewport = document.querySelector('.product-slideshow').firstElementChild;
  /*liran done*/
  
  	let fieldsetColor = document.querySelectorAll('fieldset.variant-input-wrap');
  		if (fieldsetColor) {
  			fieldsetColor.forEach((fieldset) => {
  				const name = fieldset.name.toLowerCase().trim();
  		    	if (name == 'color') {
  		      	fieldsetColor = fieldset;
  		        	
  		      }
  			})
  		  	fieldsetColor.childNodes.forEach((item)=>{
  		  		if (item.className == 'variant-input') {
  		        	item.childNodes.forEach((radio) => {
  		          	if (radio.checked) {
  		              	radio.checked = false;
  		              }
					})
  		      	}
			})
  		}
  	document.addEventListener('variant:change', function(evt) {
      	const pacItems = document.querySelectorAll('.pac_item img');
      	const eVariant = evt.detail.variant;
      	if (eVariant.featured_media.alt == 'pac') {
          	$('.product__thumbs--scroller').hide();
          	pacItems.forEach(item => {
              	let src = item.src;

				src = src.replace('_280x.jp', '.jp');
      	  		if (eVariant.featured_media.preview_image.src == src) {
                  	const height = eVariant.featured_media.preview_image.height;
                  	const width = eVariant.featured_media.preview_image.width;
                  	const aspect_ratio = eVariant.featured_media.preview_image.aspect_ratio;

      				mainImg.setAttribute('data-photoswipe-src', src);
                  	mainImg.setAttribute('data-srcset', src);
                  	mainImg.setAttribute('srcset', src);
                  	mainImg.setAttribute('data-photoswipe-height', height);
                  	mainImg.setAttribute('data-photoswipe-width', width);
                  	mainImg.setAttribute('data-aspectratio', aspect_ratio);
                  	mainImg.classList.add('mainPac');
                  
                  	if($(window).width() < 767) {

                      	$('.product-slideshow').replaceWith(mainImg);
                      	$('.mainPac').show();
                      	$("html, body").animate({ scrollTop: 0 }, "slow");

                    }
                  
                   imageWrap.style.height = "900px";
                   viewport.style.height = "900px";
      	    	}
            });
      	}
	});
  
});
